// extracted by mini-css-extract-plugin
export default {"l_FolderList_main":"FolderList_l_FolderList_main__VwTiZ"};